<template>
    <div>
      <h1>Resources</h1>
      <p>The home of trainings and other resources</p>
    </div>
</template>  